import { getAuthToken, clearAuthToken } from "../storage/authStorage"
import i18n from "i18next"
import axios from "axios"

const handleAuthError = error => {
  // If token is expired or invalid, so force user logout
  if (error?.response?.forceLogout) {
    clearAuthToken()
    window.location.href = "/login"
  }
  return Promise.reject(error)
}

const getHeaders = async (authRequired, additionalHeaders = {}) => {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Accept-Language": i18n.resolvedLanguage || "en",
    ...additionalHeaders
  }

  if (authRequired) {
    const token = getAuthToken()
    if (token) {
      headers.Authorization = `Bearer ${token}`
    }
  }

  return headers
}

// General axios request
const requestHandler = async (method, { url, data, auth }) => {
  try {
    const response = await axios({
      method,
      url: process.env.REACT_APP_API_URL + url,
      data,
      headers: await getHeaders(auth)
    })

    return response.data
  } catch (error) {
    return handleAuthError(error)
  }
}

// Standard API requests
export const getRequest = options => requestHandler("GET", options)
export const postRequest = options => requestHandler("POST", options)
export const putRequest = options => requestHandler("PUT", options)
export const patchRequest = options => requestHandler("PATCH", options)
export const deleteRequest = options => requestHandler("DELETE", options)

// File upload request
const fileRequestHandler = async (method, { url, data, auth }) => {
  try {
    const response = await axios({
      method,
      url: process.env.REACT_APP_API_URL + url,
      data,
      headers: await getHeaders(auth, { "Content-Type": "multipart/form-data" })
    })

    return response.data
  } catch (error) {
    return handleAuthError(error)
  }
}

// File API requests
export const fileRequest = options => fileRequestHandler("POST", options)
export const putFileRequest = options => fileRequestHandler("PUT", options)
export const patchFileRequest = options => fileRequestHandler("PATCH", options)
